import * as ISO from 'i18n-iso-countries'
ISO.registerLocale(require("../langs/un-en.json"));

export const getNameByISO3 = (iso3) => {
  switch(iso3){
    case 'EUN': return "European Union (EUN)"
    case 'TWN': return "Other Asia, nes"
    case 'WLD': return "World"
    case 'PUS': return "US Misc. Pacific Isds"
    case 'SCG': return "Serbia and Montenegro (..2005)"
    case 'A79': return "Rest of America, nes"
    case 'NTZ': return "Neutral Zone"
    case 'UMI': return "United States Minor Outlying Islands"
    case 'XX1': return "Areas, nes"
    case 'XX2': return "Other Europe, nes"
    case 'XX3': return "Bunkers"
    case 'XX4': return "Free Zones"
    case 'XX5': return "Special Categories"
    case 'XX6': return "LAIA, nes"
    case 'XX7': return "Oceania, nes"
    case 'XX8': return "Other Africa, nes"
    case 'XX9': return "North America and Central America, nes"
    case 'BAT': return "Br. Antartic Terr."
  }
  const countryName = ISO.getName(iso3,"en",{select: "alias"})
  if(countryName) return countryName
  return `NES, ${iso3}`;
}

export const getISO2ByISO3 = (iso3) => {
  if(iso3==='EUN') return "EU"
  if(iso3==='TWN') return "XX"
  return ISO.alpha3ToAlpha2(iso3)
}

export const shortenLargeNumber = (value) => {
  const units = ["", "k", "M", "Bn"]; 
  const thresholds = [1000, 1000000, 1000000000]; 
  let result = value; 
  const result_minus = value < 0 ? '-' : ''; 
  value = Math.abs(value); 
  for (let i = thresholds.length - 1; i >= 0; i--) {
    if (value >= thresholds[i]) { 
      result = result_minus + (value / thresholds[i]).toFixed(2) + " " + units[i + 1]; 
      break; 
    } 
  } 
  return result;
}

export const formatPercentageNumber = (value) => {
  if(Math.abs(value)<0.01){
    return '<0.01'
  }
  return (+value).toFixed(2)
}

export const formatNumber = (value)=>{
  if (isNaN(value)) {
    return '';
  }
  return new Intl.NumberFormat().format(value)
}

export const countryOptions = Object.entries(
  ISO.getNames('en', { select: 'official' })
).map(([iso2, name]) => ({
  value: ISO.alpha2ToAlpha3(iso2)!, // ISO3
  label: `${name} (${ISO.alpha2ToAlpha3(iso2)})`,
}))